module.exports = __webpack_public_path__ + "static/media/visitMallIcon.c35fdd9d.svg";